<div
  class="student-results-wrap mat-elevation-z2 overflow-auto purple-medium-dark-theme-section purple-dark-border">
  <ng-container *ngIf="results.length > 0">
    <div *ngFor="let period of results" class="mb-5 student-results-list-wrap">
      <div *ngIf="period.results[0].iterations.length > 0">
        <div class="d-flex align-items-center mb-3">
          <p class="student-results-period-title mr-2">
            Период #{{ period.number }} -
            {{ period.start_date | date: 'dd.MM.y' }} -
            {{ period.finish_date | date: 'dd.MM.y' }}
          </p>
        </div>
        <div
          class="student-results-header-cell student-results-period-result mx-2">
          Итерации
        </div>
        <div class="student-results-list">
          <div class="student-results-header">
            <div class="d-flex student-results-homeworks">
              <div
                *ngFor="let result of period.results[0].iterations"
                class="student-results-header-cell student-results-header-homeworks-wrap">
                <span class="student-results-header-homeworks">
                  #{{ result.number }}
                </span>
              </div>
            </div>

            <div class="d-flex">
              <div
                class="student-results-header-cell student-results-period-result mx-2">
                Итог
              </div>
            </div>
          </div>
          <div class="student-results-body d-flex">
            <div class="d-flex student-results-homeworks">
              <div
                *ngFor="let iteration of period.results[0].iterations"
                class="student-results-homework">
                <a
                  target="_blank"
                  matTooltip="Перейти к рецензии"
                  href="/esdp/reviews/{{ iteration['review_id'] }}">
                  {{ iteration.points }}
                </a>
              </div>
            </div>

            <div class="d-flex">
              <div
                class="student-results-cell student-results-average-points mx-2">
                {{ period.results[0].period_result }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
